<template>
  <div id="base-delete-button-vuex" v-if="idx">
    <v-btn @click="doDelete(idx)" color="red" dark>
      <slot>Delete</slot>
      <!-- default slot content: "Delete" -->
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'base-delete-button-vuex',
  props: {
    idx: {
      type: String,
      Number,
      default: null
    },
    module: {
      type: String,
      default: ''
    }
  },
  computed: {
    // permissionDelete() {
    //   return this.$store.getters['Permission/getAll'].delete
    // }
  },
  data() {
    return {}
  },
  methods: {
    async doDelete(idx) {
      try {
        const answer = window.confirm(`Do you want to Delete ${idx} ?`)
        if (answer) {
          // Delete in DB
          this.$store.dispatch(`${this.module}/delete`, idx)
          this.$store.commit(`${this.module}/UPDATE_DIALOG`, false)
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
